import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

function Dashboard() {
  const { user, logout, getToken } = useAuth();
  const navigate = useNavigate();
  const [amount, setAmount] = useState('');
  const [email, setEmail] = useState('');

  const handleSignOut = () => {
    logout();
    navigate('/login');
  };

  const handleTransfer = async () => {
    if (!amount || !email) {
      alert('Please fill in all fields');
      return;
    }

    try {
      const token = getToken();

      if (!token) {
        alert('Not authenticated. Please log in again.');
        navigate('/login');
        return;
      }

      const response = await fetch('https://cointrust-api-499312298531.us-central1.run.app/transfer_money', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ amount, email }),
      });

      if (response.ok) {
        const data = await response.json();
        alert(`Transfer Completed: ${data.transferred_amount} to ${data.email}`);
        setAmount('');
        setEmail('');
      } else {
        alert('Transfer failed. Please try again.');
      }
    } catch (error) {
      console.error('Transfer error:', error);
      alert('Transfer failed. Please try again.');
    }
  };

  return (
    <div className="container">
      <div className="sidebar">
        <div className="logo">C</div>
        <ul className="nav-list">
          <li>Home</li>
          <li>My assets</li>
          <li>Transactions</li>
          <li>Explore</li>
          <li>Derivatives</li>
          <li>Taxes</li>
          <li>Invite friends</li>
          <li>More</li>
        </ul>
        <div className="user-info">
          <div>{user?.username || user?.email || 'Authenticated User'}</div>
          <button onClick={handleSignOut}>Sign Out</button>
        </div>
      </div>

      <div className="main-content">
        <h1>Transfer Crypto</h1>

        <div className="transfer-box">
          <div className="transfer-type">
            <button className="type-btn active">Send</button>
            <button className="type-btn">Receive</button>
            <button className="type-btn">Convert</button>
          </div>

          <div className="input-group">
            <label>Amount</label>
            <input
              type="text"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="0.00"
            />
            <span className="currency">BTC</span>
          </div>

          <div className="input-group">
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="recipient@example.com"
            />
          </div>

          <button className="review-btn" onClick={handleTransfer}>
            Transfer
          </button>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
